import React, { Fragment } from "react";
import { SecondaryNav } from "../../../../components/AppChrome/components/SecondaryNav";
import { TertiaryNav } from "../../../../components/AppChrome/components/TertiaryNav";
import {
  SecondaryLinks,
  PerformanceTertiaryLinks,
} from "../../../../utils/routes/reports";

export const Navigation: React.FC = () => {
  return (
    <Fragment>
      <SecondaryNav links={SecondaryLinks} hasBottomBorder={false} />
      <TertiaryNav links={PerformanceTertiaryLinks} hasBottomBorder />
    </Fragment>
  );
};
